import { emptyArray, emptyObject } from 'ui-components/default-props/empty';

import type { ScanMode } from '../../pages/pick-pack-station/main/modes';
import { SCAN_MODES } from '../../pages/pick-pack-station/main/modes';
import type { LastScanResult } from './pick-pack-station-scan.actions';

export const selectActiveMode = (state: { activeMode?: ScanMode | null }): ScanMode => state?.activeMode ?? SCAN_MODES.verifyAndPrint;

export const selectFulfillmentPlanId = (state: { fulfillmentPlanId?: string | null }): string | null => state?.fulfillmentPlanId ?? null;

export const selectIsLoading = (state: { isLoading?: boolean | null }): boolean => state?.isLoading ?? false;

export const selectHasError = (state: { hasError?: boolean | null }): boolean => state?.hasError ?? false;

export const selectIsOrderSearch = (state: { isOrderSearch?: boolean | null }): boolean => state?.isOrderSearch ?? false;

export const selectSearchValue = (state: { searchValue?: string | null }): string => state?.searchValue ?? '';

export const selectOrderSearchResults = (state: { orderSearchResults?: readonly unknown[] | null }): readonly unknown[] =>
  state?.orderSearchResults ?? (emptyArray as unknown[]);

export const selectVerifiedItemCounts = (state: { verifiedItemCounts?: Record<string, number> | null }): Record<string, number> =>
  state?.verifiedItemCounts ?? (emptyObject as Record<string, number>);

export const selectIsVerified = (state: { isVerified?: boolean | null }): boolean => state?.isVerified ?? false;

export const selectIsSubmittingVerification = (state: { isSubmittingVerification?: boolean | null }): boolean =>
  state?.isSubmittingVerification ?? false;

export const selectIsAutoConfirmArmed = (state: { isAutoConfirmArmed?: boolean | null }): boolean => state?.isAutoConfirmArmed ?? true;

export const selectHasVerificationError = (state: { hasVerificationError?: boolean | null }): boolean =>
  state?.hasVerificationError ?? false;

export const selectHasEditedVerification = (state: { hasEditedVerification?: boolean | null }): boolean =>
  state?.hasEditedVerification ?? false;

export const selectLastScanResult = (state: { lastScanResult?: LastScanResult | null }): LastScanResult | null =>
  state?.lastScanResult ?? null;
